import {
  call, put, fork, takeLatest,
} from 'redux-saga/effects'
import * as ThemeApi from '../../api/theme'
import { FETCH_THEME_REQUEST, FETCH_THEME_SUCCESS, FETCH_THEME_FAILURE } from '../../actions/theme'

export function* fetchTheme() {
  try {
    const res = yield call(ThemeApi.fetchTheme)
    yield put({
      type: FETCH_THEME_SUCCESS,
      theme: res.theme,
    })
  } catch (err) {
    yield put({
      type: FETCH_THEME_FAILURE,
      error: err.message,
    })
  }
}

export function* watchFetchTheme() {
  yield takeLatest(FETCH_THEME_REQUEST, fetchTheme)
}

export default [
  fork(watchFetchTheme),
]
